import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

function initSliderMarquee(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-marquee").forEach((el) => {
		new Splide(el, {
			type: "loop",
			autoWidth: true,
			gap: "25px",
			pagination: false,
			arrows: false,
			drag: true,
			clones: 20,
			autoScroll: {
				speed: 0.2,
				pauseOnHover: true,
			},
		}).mount({ AutoScroll });
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderMarquee());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-marquee", ($block) => {
		initSliderMarquee($block && $block.jquery ? $block.get(0) : $block);
	});
}
